import { HelperManager } from '../utils/Helper';
import { $document, $window } from '../global';
import { dropdownManager } from './dropdown';
import { LoadingSpinner } from './loading-spinner';
import { overlayManager } from './overlay';
class CartManager {
    overlay;
    productAddedTooltip;
    btn;
    badge;
    productPriceLoadingSpinner;
    productPriceUrl;
    changeUrl;
    removeUrl;
    totalUrl;
    // Resource strings
    emptyCartText;
    productAddBtnText;
    productAddedBtnText;
    productPriceErrorText;
    addProductErrorText;
    changeProductErrorText;
    removeProductErrorText;
    currentErrors = [];
    constructor() {
        this.btn = $('.js-ShoppingCartBtn').on('click', () => {
            this.open();
        });
        this.badge = this.btn.find('.js-ShoppingCartBadge');
        this.overlay = $('.js-ShoppingCartOverlay');
        this.productAddedTooltip = $('.js-AddedProductTooltip');
        if (this.btn.length && this.productAddedTooltip.length) {
            $window.on('resize scroll', () => {
                if (this.btn.offset().top + this.btn.outerHeight() - $document.scrollTop() < 0) {
                    this.productAddedTooltip.closest('.Tooltip-AddedProduct_Wrapper2').addClass('Fixed');
                }
                else {
                    this.productAddedTooltip.closest('.Tooltip-AddedProduct_Wrapper2').removeClass('Fixed');
                }
            });
        }
        // Resource strings
        const data = $('.js-ShoppingCartData');
        if (!data.length)
            return;
        this.productPriceUrl = data.data('product-price-url');
        this.changeUrl = data.data('change-url');
        this.removeUrl = data.data('remove-url');
        this.totalUrl = data.data('total-url');
        this.productAddBtnText = data.data('product-add-btn-text') || 'Toevoegen';
        this.productAddedBtnText = data.data('product-added-btn-text') || 'Toegevoegd';
        this.productPriceErrorText = data.data('product-price-error-text') || 'De prijs kon niet worden opgehaald.';
        this.addProductErrorText = data.data('add-product-error-text') || 'De test kon niet worden toegevoegd. Controleer je internetverbinding en probeer het opnieuw.';
        this.changeProductErrorText = data.data('change-product-error-text') || 'De test kon niet worden gewijzigd. Controleer je internetverbinding en probeer het opnieuw.';
        this.removeProductErrorText = data.data('remove-product-error-text') || 'De test kon niet worden verwijderd. Controleer je internetverbinding en probeer het opnieuw.';
        this.emptyCartText = data.data('empty-cart-text') || 'U heeft geen testen geselecteerd';
        $document.ready(() => {
            this.totalRequest();
        });
    }
    get cart() {
        return $('.js-ShoppingCart');
    }
    open() {
        if (!this.overlay.length)
            return;
        overlayManager.open(this.overlay, this);
        this.totalRequest();
    }
    onClose() {
        this.removeErrorMessages();
        this.totalRequest();
    }
    lazyLoaded() {
        dropdownManager.initInContainer(this.overlay, '.js-Selectize');
    }
    addProduct(request, container, callback) {
        this.productRequest(this.changeUrl, request, (response) => {
            this.addProductSucceeded(response);
            callback(true);
        }, (response) => {
            this.addProductFailed(response, container);
            callback(false);
        });
    }
    addProductSucceeded(response) {
        if (this.badge.text() == '0' && response.totalAmount > 0) {
            setTimeout(() => {
                this.open();
            }, 1500);
        }
        this.updateProductHtml(response);
        setTimeout(() => {
            this.productAddedTooltip.stop().fadeIn().delay(3000).queue(() => {
                this.productAddedTooltip.fadeOut().dequeue();
            });
        }, 1000);
    }
    addProductFailed(response, container) {
        const message = (response.errorMessage) ? response.errorMessage : this.addProductErrorText;
        this.showErrorMessage(container, message);
    }
    productPrice(request, container, callback) {
        if (!this.productPriceUrl) {
            return;
        }
        if (!this.productPriceLoadingSpinner) {
            this.productPriceLoadingSpinner = new LoadingSpinner(true, true, true);
            this.productPriceLoadingSpinner.html.addClass('LoadingSpinner-ProductPrice');
        }
        const priceContainer = container.find('.js-Price').empty();
        this.productPriceLoadingSpinner.html.appendTo(priceContainer);
        this.productPriceLoadingSpinner.show();
        this.productRequest(this.productPriceUrl, request, (response) => {
            this.productPriceSucceeded(response);
            callback(true);
        }, (response) => {
            this.productPriceFailed(response, container);
            this.productPriceLoadingSpinner.hide();
            callback(false);
        });
    }
    productPriceSucceeded(response) {
        response.dontUpdateBtns = true;
        this.updateProductHtml(response);
    }
    productPriceFailed(response, container) {
        const message = (response.errorMessage) ? response.errorMessage : this.productPriceErrorText;
        this.showErrorMessage(container, message);
    }
    changeProduct(request, container, callback) {
        this.productRequest(this.changeUrl, request, (response) => {
            this.changeProductSucceeded(response);
            callback(true);
        }, (response) => {
            this.changeProductFailed(response, container);
            callback(false);
        });
    }
    changeProductSucceeded(response) {
        this.updateProductHtml(response);
    }
    changeProductFailed(response, container) {
        const message = (response.errorMessage) ? response.errorMessage : this.changeProductErrorText;
        this.showErrorMessage(container, message);
    }
    removeProduct(request, container, callback) {
        this.productRequest(this.removeUrl, request, (response) => {
            this.removeProductSucceeded(response);
            callback(true);
        }, (response) => {
            this.removeProductFailed(response, container);
            callback(false);
        });
    }
    removeProductSucceeded(response) {
        response.productRemoved = true;
        this.updateProductHtml(response);
    }
    removeProductFailed(response, container) {
        const message = (response.errorMessage) ? response.errorMessage : this.removeProductErrorText;
        this.showErrorMessage(container, message);
    }
    removeErrorMessages() {
        for (let i = 0; i < this.currentErrors.length; i++) {
            const message = this.currentErrors[i];
            message.remove();
        }
        this.currentErrors = [];
    }
    showErrorMessage(container, message) {
        this.removeErrorMessages();
        const errorMessage = $(`<div class="ErrorMessage">${message}</div>`);
        let errorsContainer = container.find('.js-ProductErrorMessages');
        errorsContainer = (errorsContainer.length) ? errorsContainer : container;
        errorsContainer.append(errorMessage);
        this.currentErrors.push(errorMessage);
    }
    totalRequest() {
        if (!this.totalUrl)
            return;
        const xhr = $.ajax({
            url: this.totalUrl,
            type: 'POST',
            contentType: 'application/json',
            success: (data) => {
                data = HelperManager.tryToParseToJSON(data, xhr);
                if (!data)
                    return;
                const response = data;
                if (isNaN(response.totalAmount))
                    return;
                this.updateBadge(response.totalAmount);
            }
        });
    }
    productRequest(url, request, successCallback, errorCallback) {
        this.removeErrorMessages();
        function onError(response = null) {
            response = response || new ProductChangeError();
            response.productId = request.productId;
            errorCallback(response);
        }
        const xhr = $.ajax({
            url,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(request),
            success: (data) => {
                data = HelperManager.tryToParseToJSON(data, xhr);
                if (!data) {
                    onError();
                    return;
                }
                const response = data;
                response.productId = request.productId;
                successCallback(response);
            },
            error: () => {
                const response = xhr.responseJSON;
                onError(response);
            }
        });
    }
    updateBadge(amount) {
        this.badge.text(amount);
        if (amount == 0) {
            this.badge.addClass('Hidden');
        }
        else if (this.badge.hasClass('Hidden')) {
            this.badge.removeClass('Hidden');
        }
        if (amount == 0 && this.cart.length) {
            this.cart.text(this.emptyCartText);
        }
    }
    updateProductHtml(response) {
        const cart = this.cart;
        const dataProductIdSelector = `.js-Product[data-product-id="${response.productId}"]`;
        if (!isNaN(response.totalAmount)) {
            this.updateBadge(response.totalAmount);
        }
        setTimeout(() => {
            const $product = $(dataProductIdSelector);
            if ($product.length) {
                if (response.productPrice) {
                    const $price = $product.find('.js-Price');
                    $price.text(response.productPrice);
                }
                // Buttons
                if (!response.dontUpdateBtns) {
                    const $openOptionsBtn = $product.find('.js-OpenOptionsBtn');
                    const $addBtn = $product.find('.js-AddBtn');
                    const $changeBtn = $product.find('.js-ChangeBtn');
                    const $removeBtn = $product.find('.js-RemoveBtn');
                    if (response.productRemoved) {
                        $openOptionsBtn.text(this.productAddBtnText)
                            .removeClass('Btn-Green').addClass('Btn-Default');
                        $addBtn.removeClass('Hidden');
                        $changeBtn.addClass('Hidden');
                        $removeBtn.addClass('Hidden');
                    }
                    else {
                        $openOptionsBtn.text(this.productAddedBtnText)
                            .removeClass('Btn-Default').addClass('Btn-Green');
                        $addBtn.addClass('Hidden');
                        $changeBtn.removeClass('Hidden');
                        $removeBtn.removeClass('Hidden');
                    }
                }
            }
            if (response.totalPrice) {
                const $total = cart.find('.js-TotalPrice');
                $total.text(response.totalPrice);
            }
        }, 500);
        if (response.productRemoved) {
            const $product = cart.find(dataProductIdSelector);
            $product.remove();
        }
    }
}
class ProductChangeRequest {
    productId;
    categoryId;
    options;
    constructor(productId, categoryId, options) {
        this.productId = productId;
        this.categoryId = categoryId;
        this.options = options;
    }
}
class ProductRemoveRequest {
    productId;
    constructor(id) {
        this.productId = id;
    }
}
class TotalResponse {
    totalAmount;
}
class ProductChangeResponse {
    productId;
    productPrice;
    totalPrice;
    totalAmount;
    dontUpdateBtns = false;
    productRemoved = false;
}
class ProductChangeError {
    productId;
    errorMessage;
}
const cartManager = new CartManager();
export { 
// types
CartManager, ProductChangeError, ProductChangeRequest, ProductChangeResponse, ProductRemoveRequest, 
// globals
cartManager };
